/**
 * Route segments that were renamed to camelCase (route segments are camelCase
 * throughout the app). The old URLs must keep working: the backend's IoT alert
 * notifications (Novu workflow `iot-alert`, also sent as e-mail and push) link
 * to an absolute `/assets/:id/condition-monitoring/alerts`, and old e-mails,
 * bookmarks and docs carry the other paths.
 *
 * A Map rather than an object literal, so a segment like `constructor` can
 * never hit Object.prototype.
 */
export const LEGACY_ROUTE_SEGMENTS: ReadonlyMap<string, string> = new Map([
    ['condition-monitoring', 'conditionMonitoring'],
    ['notification-settings', 'notificationSettings'],
    ['installed-base', 'installedBase'],
    ['iot-reports', 'iotReports'],
    ['iot-edit', 'iotEdit'],
    ['iot-configuration', 'iotConfiguration'],
    ['system-announcements', 'systemAnnouncements'],
    ['sla-report', 'slaReport'],
]);

/**
 * Replaces every path segment that exactly matches a legacy segment with its
 * camelCase successor. Other segments (ids, unrelated paths) stay untouched.
 */
export function rewriteLegacyPath(pathname: string): string {
    return pathname
        .split('/')
        .map(segment => LEGACY_ROUTE_SEGMENTS.get(segment) ?? segment)
        .join('/');
}
